import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PureComponent } from "react";
import { initHeaderScripts } from "/services/header-scripts-service";
import { withGenericConfig } from "/contexts/generic-config-context";
import { withAbTests } from "contexts/ab-tests-context";
import Polyfills from "components/core/head/polyfills";
import DynamicTemplatePageScriptPerformanceTracker from "components/core/head/dynamic-template-page-script-performance-tracker";
import LandingPageTracker from "components/core/head/landing-page-tracker";
import { fireGtmEvent } from "client/services/gtm-service/gtm-service";
import DataLayerEventTypes from "constants/data-layer-event-types";
import { getExactEventNameAbTestVariant } from "services/ab-tests/lp-ab-tests-service";
import BigBrainScript from "./bigbrain-script";
import LlmsTxtLinkComponent from "./llms-txt-link-component";
const isProduction = process.env.NODE_ENV === "production";
class HeaderScriptsComponent extends PureComponent {
    componentDidMount() {
        const { coupon, extendTrialCookie, marketingTemplateBoardIds, clusterId, subClusterId, clusterIdSource, pageProductId, subClusterIdSource, localeId, template, skipClustersQuestion, enablePageUsageDurationTracking, customHeadScript } = this.props;
        fireGtmEvent(DataLayerEventTypes.META_DATA, {
            page_type: pageProductId
        });
        initHeaderScripts({
            isProduction,
            coupon,
            marketingTemplateBoardIds,
            clusterId,
            subClusterId,
            localeId,
            extendTrialCookie,
            template,
            skipClustersQuestion,
            enablePageUsageDurationTracking,
            clusterIdSource,
            subClusterIdSource
        });
    }
    getGenericAbTest(abTests, abTestExactEventName) {
        const abTestVariant = getExactEventNameAbTestVariant(abTestExactEventName, abTests);
        return abTestExactEventName && abTestVariant && {
            name: abTestExactEventName,
            variant: abTestVariant
        };
    }
    render() {
        const { pageType, template, clusterId, subClusterId, customHeadScript, segmentsList, pageProductId, crossOriginLocaleAbTest } = this.props;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(BigBrainScript, {
                    isProduction: isProduction,
                    pageType: pageType,
                    template: template,
                    clusterId: clusterId,
                    subClusterId: subClusterId,
                    segmentsList: segmentsList,
                    pageProductId: pageProductId,
                    exactPageAbTest: this.exactPageAbTest,
                    crossOriginLocaleAbTest: crossOriginLocaleAbTest
                }),
                /*#__PURE__*/ _jsx(DynamicTemplatePageScriptPerformanceTracker, {}),
                /*#__PURE__*/ _jsx(LandingPageTracker, {}),
                /*#__PURE__*/ _jsx(Polyfills, {}),
                LlmsTxtLinkComponent(),
                customHeadScript && /*#__PURE__*/ _jsx("script", {
                    dangerouslySetInnerHTML: {
                        __html: customHeadScript
                    }
                })
            ]
        });
    }
    constructor(props){
        super(props);
        const { abTests, abTestExactEventName } = props;
        this.exactPageAbTest = this.getGenericAbTest(abTests, abTestExactEventName);
    }
}
export default withAbTests(withGenericConfig(HeaderScriptsComponent));
